// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme-aware surface overrides for legacy page CSS.
   Maps hardcoded light-only values to design tokens across ALL routes. */

/* ─── Page roots ─── */
.test-cases-overview-container,
.test-suites-overview-container,
.test-suites-container,
.test-plans-container,
.projects-container,
.all-workspaces-container,
.learning-system,
.learning-container,
.settings-container,
.report-page-container,
.reports-container,
.jira-items-container,
.optimization-container,
.ai-testcase-generator-container,
.detailed-report-container,
.schedule-plan-container {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
}

/* ─── Headers / titles ─── */
.test-cases-overview-title,
.test-suites-overview-title,
.test-plans-title,
.projects-title,
.settings-title,
.settings-section-title,
.settings-card-title,
.report-page-title,
.learning-title,
.all-workspaces-title,
.sectionTitle {
  color: var(--text-primary) !important;
}

.test-cases-overview-subtitle,
.test-suites-overview-subtitle,
.settings-subtitle,
.settings-card-description,
.projects-subtitle,
.report-page-subtitle,
.learning-subtitle {
  color: var(--text-secondary) !important;
}

/* ─── Settings ─── */
.settings-container,
.settings-sidebar,
.settings-content,
.settings-card,
.settings-nav,
.settings-layout {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary);
}

.settings-container {
  background: transparent !important;
}

.settings-sidebar,
.settings-content,
.settings-card {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.settings-nav-item {
  color: var(--text-secondary) !important;
  border-radius: var(--radius-md);
}

.settings-nav-item:hover,
.settings-nav-item.active {
  background: var(--primary-muted) !important;
  color: var(--primary) !important;
}

.settings-form-group label,
.settings-label {
  color: var(--text-secondary) !important;
}

/* ─── Inputs (global) ─── */
input[type="text"],
input[type="search"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="date"],
input[type="datetime-local"],
input[type="url"],
input[type="tel"],
input:not([type]),
select,
textarea,
.filter-select,
.search-input,
.rt-select {
  background-color: var(--input-background) !important;
  color: var(--text-primary) !important;
  border-color: var(--input-border, var(--border)) !important;
}

input::placeholder,
textarea::placeholder,
.search-input::placeholder {
  color: var(--input-placeholder, var(--text-muted)) !important;
}

input:focus,
select:focus,
textarea:focus,
.filter-select:focus,
.search-input:focus {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-color: var(--primary) !important;
}

/* Command palette input is flush — never inherit global field chrome */
.rt2-cmd input,
.rt2-cmd input[type="search"],
.rt2-cmd input:focus,
.rt2-cmd__input,
.rt2-cmd__input:focus {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}

input:disabled,
select:disabled,
textarea:disabled {
  opacity: 0.6;
  background: var(--bg-tertiary) !important;
  color: var(--text-muted) !important;
}

/* ─── Cards / panels / filters ─── */
.test-cases-filters,
.test-suites-filters,
.test-plans-filters,
.report-filters,
.filter-bar,
.stats-summary,
.test-cases-stats-summary,
.test-suites-stats-summary,
.summary-cards,
.summary-card,
.stat-card-container,
.project-card,
.workspace-card,
.learning-card,
.chart-card,
.chartContainer,
.dashboard-card,
.recent-activity,
.section-card,
.panel,
.card {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
  box-shadow: var(--shadow-sm);
}

.stat-card::after,
.stat-card:not(:last-child)::after {
  background-color: var(--border) !important;
}

.stat-value,
.stat-number {
  color: var(--text-primary) !important;
}

.stat-label {
  color: var(--text-muted) !important;
}

/* ─── Tables ─── */
table,
.projects-table,
.test-cases-table,
.test-suites-table,
.test-plans-table,
.reports-table,
.rt-table,
.data-table,
.MuiTable-root {
  background: var(--table-surface, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--table-border, var(--border)) !important;
}

thead,
table th,
.projects-table th,
.test-cases-table th,
.test-suites-table th,
.test-plans-table th,
.reports-table th,
.rt-table th {
  background: var(--table-header, var(--bg-tertiary)) !important;
  color: var(--text-muted) !important;
  border-color: var(--table-border, var(--border)) !important;
}

table td,
.projects-table td,
.test-cases-table td,
.test-suites-table td,
.test-plans-table td,
.reports-table td {
  color: var(--text-primary) !important;
  border-color: var(--border-subtle) !important;
  background: transparent !important;
}

table tbody tr:hover td,
.projects-table tr:hover td,
.test-cases-table tr:hover td,
.test-suites-table tr:hover td,
.test-plans-table tr:hover td {
  background: var(--table-hover, var(--surface-hover)) !important;
}

/* Sticky table headers inside themed tables */
table thead th,
.sticky-header {
  background: var(--table-header, var(--bg-tertiary)) !important;
}

/* ─── Modals / drawers / popovers ─── */
.modal-content,
.modal-body,
.modal-header,
.modal-footer,
.modal,
.ReactModal__Content,
.drawer,
.popover,
.dropdown-menu,
.filter-dropdown-menu,
.rt-dropdown,
.rt-cmd,
.rt-action-menu {
  background: var(--surface-raised, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
  text-shadow: none !important;
}

/* Action menu: one floating surface; never re-surface nested text */
.rt-action-menu button,
.rt-action-menu [role='menuitem'],
.rt-action-menu span,
.rt-action-menu p,
.rt-action-menu strong,
.rt-action-menu svg {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
  border-color: transparent !important;
  filter: none !important;
}

.rt-action-menu button:hover:not(:disabled),
.rt-action-menu [role='menuitem']:hover:not(:disabled),
.rt-action-menu button:focus-visible:not(:disabled),
.rt-action-menu [role='menuitem']:focus-visible:not(:disabled) {
  background: rgba(59, 130, 246, 0.08) !important;
  background-color: rgba(59, 130, 246, 0.08) !important;
}

[data-theme='dark'] .rt-action-menu button:hover:not(:disabled),
[data-theme='dark'] .rt-action-menu [role='menuitem']:hover:not(:disabled),
[data-theme='dark'] .rt-action-menu button:focus-visible:not(:disabled),
[data-theme='dark'] .rt-action-menu [role='menuitem']:focus-visible:not(:disabled) {
  background: rgba(59, 130, 246, 0.12) !important;
  background-color: rgba(59, 130, 246, 0.12) !important;
}

.rt-action-menu .rt-action-menu__item--danger:hover:not(:disabled) {
  background: var(--danger-muted, rgba(220, 38, 38, 0.12)) !important;
  background-color: var(--danger-muted, rgba(220, 38, 38, 0.12)) !important;
}

.rt-action-menu .rt-action-menu__divider {
  background: var(--border-subtle, var(--border)) !important;
  box-shadow: none !important;
  border: none !important;
  height: 1px !important;
}

.modal-overlay,
.ReactModal__Overlay,
.modal-backdrop,
.create-test-case-modal-overlay,
.create-test-case-options-modal-overlay,
.extension-recording-modal-overlay {
  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65)) !important;
}

.modal.view-mode,
.view-mode {
  background-color: var(--bg-tertiary) !important;
  border-color: var(--border) !important;
}

/* Portal filter menus (inline styles often hardcode white) */
.rt-filter-menu,
[class*="filter"][role="listbox"],
ul[role="listbox"] {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
  box-shadow: var(--shadow-lg) !important;
}

ul[role="listbox"] li,
ul[role="listbox"] button {
  color: var(--text-primary) !important;
}

ul[role="listbox"] li:hover,
ul[role="listbox"] button:hover {
  background: var(--surface-hover) !important;
}

/* ─── Buttons ─── */
.navbar-button.primary,
.btn-primary,
.btn.primary,
button.primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

.navbar-button.primary:hover,
.btn-primary:hover {
  background: var(--primary-hover) !important;
}

.navbar-button.secondary,
.btn-secondary,
.btn.secondary,
button.secondary {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

.navbar-button.secondary:hover,
.btn-secondary:hover {
  background: var(--surface-hover) !important;
}

.navbar-button:not(.primary):not(.secondary) {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

.navbar-button:disabled,
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ─── Badges (subtle tinted) ─── */
.badge-success,
.status-badge.passed,
.status-passed,
.badge.passed {
  background: var(--success-muted) !important;
  color: var(--success) !important;
  border: none !important;
}

.badge-warning,
.status-badge.pending,
.status-pending,
.badge.pending,
.badge.warning {
  background: var(--warning-muted) !important;
  color: var(--warning) !important;
  border: none !important;
}

.badge-danger,
.status-badge.failed,
.status-failed,
.badge.failed,
.badge.danger {
  background: var(--danger-muted) !important;
  color: var(--danger) !important;
  border: none !important;
}

.badge-primary,
.status-badge.active,
.badge.info {
  background: var(--primary-muted) !important;
  color: var(--primary) !important;
  border: none !important;
}

/* ─── Status tabs ─── */
.projects-container .border-gray-300,
.status-tabs-container {
  border-color: var(--border) !important;
}

.status-tab {
  background: var(--surface) !important;
  color: var(--text-secondary) !important;
  border-color: var(--border) !important;
}

.status-tab.active {
  background: var(--primary-muted) !important;
  color: var(--primary) !important;
  border-color: transparent !important;
}

/* ─── Welcome banner ─── */
.welcome-banner {
  background: var(--primary-muted) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl, 12px);
  color: var(--text-primary);
}

.welcome-banner-title {
  color: var(--text-primary) !important;
}

.welcome-banner-message {
  color: var(--text-secondary) !important;
}

/* ─── Tooltips ─── */
.tooltip,
[role="tooltip"],
.recharts-tooltip-wrapper .recharts-default-tooltip {
  background: var(--chart-tooltip-bg, var(--surface-elevated)) !important;
  color: var(--chart-tooltip-text, var(--text-primary)) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-md) !important;
}

/* ─── Charts ─── */
.recharts-wrapper,
.recharts-surface {
  background: transparent !important;
}

.recharts-cartesian-grid line {
  stroke: var(--chart-grid) !important;
}

.recharts-text,
.recharts-cartesian-axis-tick-value {
  fill: var(--chart-tick) !important;
}

/* ─── Pagination (align legacy wrappers with soft RT2 theme) ─── */
.pagination,
.pagination-container,
.Pagination {
  color: var(--text-muted);
}

.pagination .rt-pagination,
.pagination-container .rt-pagination,
.project-pagination .rt-pagination {
  border-top-color: var(--border-subtle);
}

.pagination button,
.pagination a,
.page-btn,
.pagination-btn,
.pagination-button {
  background: transparent !important;
  color: var(--text-secondary) !important;
  border-color: transparent !important;
  border-radius: 999px !important;
}

.pagination button:hover:not(:disabled),
.pagination a:hover,
.page-btn:hover:not(:disabled),
.pagination-btn:hover:not(:disabled),
.pagination-button:hover:not(:disabled) {
  background: var(--surface-hover, rgba(15, 23, 42, 0.04)) !important;
  color: var(--text-primary) !important;
}

.pagination button.active,
.page-btn.active,
.pagination .active,
.pagination-btn.active {
  background: var(--primary-muted) !important;
  color: var(--primary) !important;
  border-color: transparent !important;
}

/* ─── Error / empty states ─── */
.error-state,
.empty-state,
.rt-error-state,
.rt-empty-state {
  background: var(--surface);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

/* ─── Learning / AI page ─── */
.learning-system,
.learning-container {
  background: var(--bg-primary) !important;
}

.learning-system .card,
.learning-system .panel,
.feedback-card {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

/* ─── Reports ─── */
.report-page-container,
.reports-container,
.detailed-report-container {
  background: var(--bg-primary) !important;
}

.metric-card,
.report-metric,
.kpi-card {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

/* ─── Test plans / executions ─── */
.test-plans-container .empty-state,
.test-plans-error,
.projects-error {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
}

/* ─── Workspaces ─── */
.all-workspaces-container .workspace-card,
.workspace-item {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

/* ─── Project list sticky / layout ─── */
.projects-container.projects-list-layout {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

/* ─── Hardcoded white/light remnants inside dark mode ─── */
[data-theme="dark"] .bg-white,
[data-theme="dark"] .bg-gray-50,
[data-theme="dark"] .bg-gray-100,
[data-theme="dark"] [style*="background: white"],
[data-theme="dark"] [style*="background: #fff"],
[data-theme="dark"] [style*="background:#fff"],
[data-theme="dark"] [style*="background-color: white"],
[data-theme="dark"] [style*="background-color: #fff"],
[data-theme="dark"] [style*="backgroundColor: '#fff'"] {
  background-color: var(--surface) !important;
}

[data-theme="dark"] .text-gray-900,
[data-theme="dark"] .text-black {
  color: var(--text-primary) !important;
}

[data-theme="dark"] .text-gray-500,
[data-theme="dark"] .text-gray-600 {
  color: var(--text-secondary) !important;
}

[data-theme="dark"] .border-gray-200,
[data-theme="dark"] .border-gray-300 {
  border-color: var(--border) !important;
}

/* ─── Layout / scroll stabilization for legacy page roots ─── */
.test-cases-overview-container,
.test-suites-overview-container,
.test-suites-container,
.test-plans-container,
.projects-container,
.projects-container.projects-list-layout,
.all-workspaces-container,
.learning-system,
.learning-container,
.settings-container,
.report-page-container,
.reports-container,
.jira-items-container,
.optimization-container,
.ai-testcase-generator-container,
.detailed-report-container,
.schedule-plan-container,
.dashboard-container,
.dashboard-content {
  height: auto !important;
  max-height: none !important;
  min-height: 0 !important;
  overflow: visible !important;
}

.projects-table-container,
.test-cases-table-container,
.test-suites-table-container,
.test-plans-table-wrapper,
.rt-table-wrap,
.rt2-table-wrap {
  overflow-x: auto !important;
  overflow-y: visible !important;
  max-height: none !important;
}

/* ─── react-select theming ───
   IMPORTANT: always require the emotion \`css-\` prefix.
   Bare [class*="-menu"] also matched our product classes
   (e.g. rt-action-menu__label) and painted every nested
   text node as its own bordered/shadowed surface. */
.css-13cymwt-control,
.css-t3ipsp-control,
[class*="css-"][class*="-control"] {
  background-color: var(--input-background) !important;
  border-color: var(--input-border) !important;
  color: var(--text-primary) !important;
  min-height: 40px !important;
  border-radius: var(--radius-md) !important;
}

[class*="css-"][class*="-menu"] {
  background-color: var(--surface-raised, var(--surface)) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-md) !important;
  color: var(--text-primary) !important;
}

[class*="css-"][class*="-option"] {
  background-color: transparent !important;
  color: var(--text-primary) !important;
}

[class*="css-"][class*="-option"]:hover,
[class*="css-"][class*="-option--is-focused"] {
  background-color: var(--surface-hover) !important;
}

[class*="css-"][class*="-singleValue"],
[class*="css-"][class*="-Input"] input,
[class*="css-"][class*="-placeholder"] {
  color: var(--text-primary) !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

[class*="css-"][class*="-placeholder"] {
  color: var(--input-placeholder) !important;
}

[class*="css-"][class*="-multiValue"] {
  background: var(--primary-muted) !important;
}

[class*="css-"][class*="-multiValue__label"] {
  color: var(--primary) !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* Toast / notification surfaces */
.Toastify__toast,
.toast {
  background: var(--surface-elevated) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border);
}


/* ─── Create Test Case options / form / extension modals ─── */
.create-test-case-options-modal-panel,
.create-test-case-modal-panel,
.extension-recording-modal-panel {
  background: var(--modal-background, var(--surface)) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border-strong, var(--border)) !important;
  box-shadow: var(--modal-shadow, var(--shadow-lg)) !important;
}

.create-test-case-options-modal-body,
.create-test-case-modal-panel .modal-body {
  background: var(--modal-background, var(--surface)) !important;
  color: var(--text-primary) !important;
}

/* Light: keep footer flush with body so it doesn’t look muddy gray-on-white */
[data-theme="light"] .create-test-case-options-modal-footer,
:root:not([data-theme="dark"]) .create-test-case-options-modal-footer,
[data-theme="light"] .create-test-case-modal-panel .modal-footer,
:root:not([data-theme="dark"]) .create-test-case-modal-panel .modal-footer {
  background: var(--modal-background, #fff) !important;
  border-top: 1px solid var(--border) !important;
}

[data-theme="dark"] .create-test-case-options-modal-footer,
[data-theme="dark"] .create-test-case-modal-panel .modal-footer {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  border-top: 1px solid var(--border) !important;
}

.create-test-case-option-btn {
  background: var(--surface-raised, var(--surface)) !important;
  border: 1px solid var(--border-strong, var(--border)) !important;
  color: var(--text-primary) !important;
  box-shadow: var(--shadow-xs);
}

[data-theme="light"] .create-test-case-option-btn,
:root:not([data-theme="dark"]) .create-test-case-option-btn {
  background: #fff !important;
  border-color: #CBD5E1 !important;
}

.create-test-case-option-btn:hover {
  border-color: var(--primary) !important;
  background: var(--primary-muted) !important;
}

.create-test-case-option-btn.extension:hover {
  border-color: #22c55e !important;
  background: rgba(34, 197, 94, 0.14) !important;
}

.create-test-case-option-btn.disabled:hover {
  border-color: var(--border) !important;
  background: var(--surface-hover) !important;
}

.create-test-case-option-title {
  color: var(--text-primary) !important;
}

.create-test-case-option-desc {
  color: var(--text-secondary) !important;
}

.create-test-case-options-cancel-btn {
  color: var(--text-secondary) !important;
}

.create-test-case-options-cancel-btn:hover {
  color: var(--text-primary) !important;
  background: var(--surface-hover) !important;
}

.create-test-case-option-icon.manual {
  background: var(--primary-muted) !important;
}

.create-test-case-option-icon.extension {
  background: rgba(34, 197, 94, 0.18) !important;
}

.create-test-case-option-coming-soon {
  background: var(--bg-tertiary) !important;
  color: var(--text-secondary) !important;
  border: 1px solid var(--border);
}

/* Light scrim: dim the page enough that a white modal clearly floats */
[data-theme="light"] .create-test-case-options-modal-overlay,
[data-theme="light"] .create-test-case-modal-overlay,
[data-theme="light"] .extension-recording-modal-overlay,
:root:not([data-theme="dark"]) .create-test-case-options-modal-overlay,
:root:not([data-theme="dark"]) .create-test-case-modal-overlay,
:root:not([data-theme="dark"]) .extension-recording-modal-overlay {
  background: rgba(15, 23, 42, 0.48) !important;
  backdrop-filter: blur(2px);
}

[data-theme="dark"] .create-test-case-options-modal-overlay,
[data-theme="dark"] .create-test-case-modal-overlay,
[data-theme="dark"] .extension-recording-modal-overlay {
  background: rgba(2, 8, 20, 0.72) !important;
  backdrop-filter: blur(3px);
}

/* ─── Test plan modals (create / link suites / run) ─── */
.link-test-suites-modal-overlay,
.test-execution-modal-overlay,
.rt-run-plan-overlay {
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55)) !important;
}

[data-theme="dark"] .link-test-suites-modal-overlay,
[data-theme="dark"] .test-execution-modal-overlay,
[data-theme="dark"] .rt-run-plan-overlay {
  background: rgba(2, 8, 20, 0.72) !important;
  backdrop-filter: blur(3px);
}

.link-test-suites-modal,
.test-execution-modal,
.rt-run-plan-panel {
  background: var(--modal-background, var(--surface)) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--modal-shadow, var(--shadow-lg)) !important;
}

.link-test-suites-modal .modal-header,
.test-execution-modal .modal-header,
.rt-run-plan-panel .rt-run-plan-header {
  background: linear-gradient(to right, var(--primary), var(--primary-hover)) !important;
  border-bottom-color: transparent !important;
}

.link-test-suites-modal .modal-content,
.link-test-suites-modal-form,
.test-execution-modal .modal-content,
.test-execution-modal-form {
  background: var(--modal-background, var(--surface)) !important;
  color: var(--text-primary) !important;
}

.link-test-suites-modal .modal-footer,
.test-execution-modal .modal-footer,
.rt-run-plan-panel .rt-run-plan-footer {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  border-top: 1px solid var(--border) !important;
}

[data-theme="light"] .link-test-suites-modal .modal-footer,
[data-theme="light"] .test-execution-modal .modal-footer,
[data-theme="light"] .rt-run-plan-panel .rt-run-plan-footer {
  background: var(--modal-background, #fff) !important;
}

.link-test-suites-modal .suite-item,
.link-test-suites-modal .test-suites-vertical-list,
.link-test-suites-modal .test-suites-container {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.link-test-suites-modal .suite-item:hover,
.link-test-suites-modal .suite-item.selected {
  background: var(--primary-muted) !important;
  border-color: var(--primary) !important;
}

.link-test-suites-modal .suite-name,
.link-test-suites-modal .selection-count,
.link-test-suites-modal .form-group > label,
.link-test-suites-modal .empty-state,
.link-test-suites-modal .loading-state {
  color: var(--text-primary) !important;
}

.link-test-suites-modal .btn.secondary,
.test-execution-modal .btn.secondary {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
}

.link-test-suites-modal .btn.primary,
.test-execution-modal .btn.primary {
  background: var(--primary) !important;
  color: #fff !important;
  border: 1px solid transparent !important;
}

.link-test-suites-modal .btn.danger {
  background: var(--danger) !important;
  color: #fff !important;
}

.test-execution-modal .form-group > label,
.test-execution-modal .form-info p,
.test-execution-field-hint {
  color: var(--text-secondary) !important;
}

.test-execution-modal input,
.test-execution-modal textarea,
.test-execution-modal select {
  background: var(--input-background) !important;
  color: var(--text-primary) !important;
  border-color: var(--input-border) !important;
}

/* View plan modal (edit) */
.rt-plan-as-page,
.rt-plan-as-page > div {
  background: transparent !important;
  color: var(--text-primary) !important;
}

/* ─── Global: kill accidental text-level surfaces ─── */
.rt2-main p,
.rt2-main h1,
.rt2-main h2,
.rt2-main h3,
.rt2-main h4,
.rt2-main h5,
.rt2-main h6,
.rt2-main label,
.rt2-main small,
.rt2-main strong,
.rt2-main em,
.rt2-main .page-subtitle,
.rt2-main .section-subtitle,
.rt2-main .breadcrumb,
.rt2-main .breadcrumb *,
.rt2-cmd__item-title,
.rt2-cmd__item-desc,
.rt2-sidebar__label,
.rt2-topbar__crumb,
.dropdown-menu button,
.dropdown-menu span,
.action-submenu-item,
.action-submenu-item span,
ul[role="listbox"] [role="option"],
ul[role="listbox"] [role="option"] * {
  text-shadow: none;
}

.rt2-main p,
.rt2-main h1,
.rt2-main h2,
.rt2-main h3,
.rt2-main h4,
.rt2-main h5,
.rt2-main h6,
.rt2-main label:not([class*="toggle"]):not([class*="switch"]),
.rt2-main small,
.rt2-main strong,
.rt2-main em,
.rt2-cmd__item-title,
.rt2-cmd__item-desc,
.dropdown-menu span,
.action-submenu-item span,
ul[role="listbox"] [role="option"] span {
  background: transparent;
  box-shadow: none;
}

.dropdown-menu,
.filter-dropdown-menu,
.rt-dropdown,
.rt-filter-menu,
ul[role="listbox"] {
  background: var(--surface-raised, var(--surface)) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-md) !important;
  color: var(--text-primary) !important;
}

.dropdown-menu button:hover,
.action-submenu-item:hover:not(:disabled),
ul[role="listbox"] [role="option"]:hover,
ul[role="listbox"] [role="option"][aria-selected="true"] {
  background: rgba(59, 130, 246, 0.08) !important;
}

[data-theme="dark"] .dropdown-menu button:hover,
[data-theme="dark"] .action-submenu-item:hover:not(:disabled),
[data-theme="dark"] ul[role="listbox"] [role="option"]:hover,
[data-theme="dark"] ul[role="listbox"] [role="option"][aria-selected="true"] {
  background: rgba(59, 130, 246, 0.12) !important;
}

/* ─── Legacy light surfaces → tokens (Jira / scenarios / modals / cards) ─── */
.jira-items-content,
.jira-items-tabs {
  background: transparent !important;
  background-color: transparent !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
  box-shadow: none !important;
}

.epic-details,
.epic-dropdown,
.test-cases-modal,
.test-cases-modal-content,
.test-cases-modal-body,
.scenario-test-cases,
.editable-parameter-group,
.analysis-results,
.item-details,
.test-case-card,
.test-plan-card,
.test-suite-card,
.test-case-editor {
  background: var(--surface) !important;
  background-color: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.ai-testcase-generator-overlay.rt-scenario-page {
  background: transparent !important;
}

.ai-testcase-generator-container.rt-scenario-panel,
.rt-scenario-page .ai-testcase-generator-container,
.generator-content {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
}

.bdd-step,
.expected-result,
.collapsed-summary,
.parameter-value {
  background: var(--bg-tertiary, var(--surface-hover)) !important;
  color: var(--text-primary) !important;
}

/* Flat typography — never invent boxes behind labels */
.test-case-section h4,
.test-case-section > h4,
.test-strategy-section h4,
.test-suites-section h4,
.scenario-test-cases h4,
.epic-stories h4,
.ai-testcase-generator-container h3,
.ai-testcase-generator-container h4,
.ai-testcase-generator-container label,
.jira-items-container h3,
.jira-items-container h4,
.jira-items-container label,
.rt2-main h1,
.rt2-main h2,
.rt2-main h3,
.rt2-main h4,
.rt2-main h5,
.rt2-main h6,
.rt2-main p,
.rt2-main label:not([class*="toggle"]):not([class*="switch"]),
.rt2-main small,
.rt2-main strong,
.rt2-main em {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.epic-dropdown label,
.epic-dropdown select {
  color: var(--text-primary) !important;
}

.epic-dropdown select {
  background: var(--input-background, var(--surface)) !important;
  border-color: var(--input-border, var(--border)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme/legacy-overrides.css"],"names":[],"mappings":"AAAA;yEACyE;;AAEzE,uBAAuB;AACvB;;;;;;;;;;;;;;;;EAgBE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;;;;;;;;;;;EAWE,qCAAqC;AACvC;;AAEA;;;;;;;EAOE,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;;;;;;EAME,qCAAqC;EACrC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;;;;;;;;;;;;;;;EAeE,oDAAoD;EACpD,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;;;EAGE,6DAA6D;AAC/D;;AAEA;;;;;EAKE,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,uEAAuE;AACvE;;;;;EAKE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;EAGE,YAAY;EACZ,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;;;;;;;;;;;;;;;;;;;;;EAqBE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;;;;;;;;;EASE,2DAA2D;EAC3D,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;;;;;;;;EAQE,8DAA8D;EAC9D,mCAAmC;EACnC,2DAA2D;AAC7D;;AAEA;;;;;;EAME,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;;;;;EAKE,+DAA+D;AACjE;;AAEA,8CAA8C;AAC9C;;EAEE,8DAA8D;AAChE;;AAEA,wCAAwC;AACxC;;;;;;;;;;;;;EAaE,4DAA4D;EAC5D,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,oEAAoE;AACpE;;;;;;EAME,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;;;EAIE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;;;;EAIE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,mEAAmE;EACnE,yEAAyE;AAC3E;;AAEA;EACE,0DAA0D;EAC1D,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;EAME,iEAAiE;AACnE;;AAEA;;EAEE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA,6DAA6D;AAC7D;;;EAGE,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;;;;EAIE,qCAAqC;EACrC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;;;EAIE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;;;;EAIE,2CAA2C;EAC3C,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;;;EAKE,2CAA2C;EAC3C,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;;;EAKE,0CAA0C;EAC1C,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;EAGE,2CAA2C;EAC3C,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;;EAEE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;;;EAGE,uEAAuE;EACvE,gEAAgE;EAChE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;;EAEE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;;;;;EAKE,kCAAkC;EAClC,uCAAuC;EACvC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;;;;;EAKE,mEAAmE;EACnE,qCAAqC;AACvC;;AAEA;;;;EAIE,2CAA2C;EAC3C,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;;;;EAIE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;;EAEE,wCAAwC;AAC1C;;AAEA;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;;;;;;;;;EASE,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA,gEAAgE;AAChE;;;;;;;;;;;;;;;;;;;EAmBE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;;;;;EAME,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;;oDAIoD;AACpD;;;EAGE,oDAAoD;EACpD,4CAA4C;EAC5C,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kEAAkE;EAClE,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;;EAGE,qCAAqC;EACrC,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;;EAEE,8CAA8C;EAC9C,qCAAqC;EACrC,+BAA+B;AACjC;;;AAGA,+DAA+D;AAC/D;;;EAGE,8DAA8D;EAC9D,qCAAqC;EACrC,gEAAgE;EAChE,4DAA4D;AAC9D;;AAEA;;EAEE,8DAA8D;EAC9D,qCAAqC;AACvC;;AAEA,8EAA8E;AAC9E;;;;EAIE,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;;EAEE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,4DAA4D;EAC5D,gEAAgE;EAChE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;;;;;;EAME,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;;;EAGE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;;;EAGE,oEAAoE;AACtE;;AAEA;;;EAGE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;;;EAGE,8DAA8D;EAC9D,qCAAqC;EACrC,0CAA0C;EAC1C,4DAA4D;AAC9D;;AAEA;;;EAGE,sFAAsF;EACtF,2CAA2C;AAC7C;;AAEA;;;;EAIE,8DAA8D;EAC9D,qCAAqC;AACvC;;AAEA;;;EAGE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;;;EAGE,oDAAoD;AACtD;;AAEA;;;EAGE,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;EAEE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;EAEE,qCAAqC;EACrC,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;EAGE,8CAA8C;EAC9C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;;EAEE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;EAKE,4DAA4D;EAC5D,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA,+EAA+E;AAC/E;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;EAaE,qCAAqC;EACrC,2CAA2C;EAC3C,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EAGE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;;;EAIE,+DAA+D;EAC/D,qCAAqC;AACvC;;AAEA,uDAAuD;AACvD;;;;;;;;;;;;;;;;;;;;;;;EAuBE,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,8DAA8D;EAC9D,2DAA2D;AAC7D","sourcesContent":["/* Theme-aware surface overrides for legacy page CSS.\n   Maps hardcoded light-only values to design tokens across ALL routes. */\n\n/* ─── Page roots ─── */\n.test-cases-overview-container,\n.test-suites-overview-container,\n.test-suites-container,\n.test-plans-container,\n.projects-container,\n.all-workspaces-container,\n.learning-system,\n.learning-container,\n.settings-container,\n.report-page-container,\n.reports-container,\n.jira-items-container,\n.optimization-container,\n.ai-testcase-generator-container,\n.detailed-report-container,\n.schedule-plan-container {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Headers / titles ─── */\n.test-cases-overview-title,\n.test-suites-overview-title,\n.test-plans-title,\n.projects-title,\n.settings-title,\n.settings-section-title,\n.settings-card-title,\n.report-page-title,\n.learning-title,\n.all-workspaces-title,\n.sectionTitle {\n  color: var(--text-primary) !important;\n}\n\n.test-cases-overview-subtitle,\n.test-suites-overview-subtitle,\n.settings-subtitle,\n.settings-card-description,\n.projects-subtitle,\n.report-page-subtitle,\n.learning-subtitle {\n  color: var(--text-secondary) !important;\n}\n\n/* ─── Settings ─── */\n.settings-container,\n.settings-sidebar,\n.settings-content,\n.settings-card,\n.settings-nav,\n.settings-layout {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary);\n}\n\n.settings-container {\n  background: transparent !important;\n}\n\n.settings-sidebar,\n.settings-content,\n.settings-card {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.settings-nav-item {\n  color: var(--text-secondary) !important;\n  border-radius: var(--radius-md);\n}\n\n.settings-nav-item:hover,\n.settings-nav-item.active {\n  background: var(--primary-muted) !important;\n  color: var(--primary) !important;\n}\n\n.settings-form-group label,\n.settings-label {\n  color: var(--text-secondary) !important;\n}\n\n/* ─── Inputs (global) ─── */\ninput[type=\"text\"],\ninput[type=\"search\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"datetime-local\"],\ninput[type=\"url\"],\ninput[type=\"tel\"],\ninput:not([type]),\nselect,\ntextarea,\n.filter-select,\n.search-input,\n.rt-select {\n  background-color: var(--input-background) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--input-border, var(--border)) !important;\n}\n\ninput::placeholder,\ntextarea::placeholder,\n.search-input::placeholder {\n  color: var(--input-placeholder, var(--text-muted)) !important;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\n.filter-select:focus,\n.search-input:focus {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n  border-color: var(--primary) !important;\n}\n\n/* Command palette input is flush — never inherit global field chrome */\n.rt2-cmd input,\n.rt2-cmd input[type=\"search\"],\n.rt2-cmd input:focus,\n.rt2-cmd__input,\n.rt2-cmd__input:focus {\n  background: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\ninput:disabled,\nselect:disabled,\ntextarea:disabled {\n  opacity: 0.6;\n  background: var(--bg-tertiary) !important;\n  color: var(--text-muted) !important;\n}\n\n/* ─── Cards / panels / filters ─── */\n.test-cases-filters,\n.test-suites-filters,\n.test-plans-filters,\n.report-filters,\n.filter-bar,\n.stats-summary,\n.test-cases-stats-summary,\n.test-suites-stats-summary,\n.summary-cards,\n.summary-card,\n.stat-card-container,\n.project-card,\n.workspace-card,\n.learning-card,\n.chart-card,\n.chartContainer,\n.dashboard-card,\n.recent-activity,\n.section-card,\n.panel,\n.card {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n  box-shadow: var(--shadow-sm);\n}\n\n.stat-card::after,\n.stat-card:not(:last-child)::after {\n  background-color: var(--border) !important;\n}\n\n.stat-value,\n.stat-number {\n  color: var(--text-primary) !important;\n}\n\n.stat-label {\n  color: var(--text-muted) !important;\n}\n\n/* ─── Tables ─── */\ntable,\n.projects-table,\n.test-cases-table,\n.test-suites-table,\n.test-plans-table,\n.reports-table,\n.rt-table,\n.data-table,\n.MuiTable-root {\n  background: var(--table-surface, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--table-border, var(--border)) !important;\n}\n\nthead,\ntable th,\n.projects-table th,\n.test-cases-table th,\n.test-suites-table th,\n.test-plans-table th,\n.reports-table th,\n.rt-table th {\n  background: var(--table-header, var(--bg-tertiary)) !important;\n  color: var(--text-muted) !important;\n  border-color: var(--table-border, var(--border)) !important;\n}\n\ntable td,\n.projects-table td,\n.test-cases-table td,\n.test-suites-table td,\n.test-plans-table td,\n.reports-table td {\n  color: var(--text-primary) !important;\n  border-color: var(--border-subtle) !important;\n  background: transparent !important;\n}\n\ntable tbody tr:hover td,\n.projects-table tr:hover td,\n.test-cases-table tr:hover td,\n.test-suites-table tr:hover td,\n.test-plans-table tr:hover td {\n  background: var(--table-hover, var(--surface-hover)) !important;\n}\n\n/* Sticky table headers inside themed tables */\ntable thead th,\n.sticky-header {\n  background: var(--table-header, var(--bg-tertiary)) !important;\n}\n\n/* ─── Modals / drawers / popovers ─── */\n.modal-content,\n.modal-body,\n.modal-header,\n.modal-footer,\n.modal,\n.ReactModal__Content,\n.drawer,\n.popover,\n.dropdown-menu,\n.filter-dropdown-menu,\n.rt-dropdown,\n.rt-cmd,\n.rt-action-menu {\n  background: var(--surface-raised, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n  text-shadow: none !important;\n}\n\n/* Action menu: one floating surface; never re-surface nested text */\n.rt-action-menu button,\n.rt-action-menu [role='menuitem'],\n.rt-action-menu span,\n.rt-action-menu p,\n.rt-action-menu strong,\n.rt-action-menu svg {\n  background: transparent !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n  border-color: transparent !important;\n  filter: none !important;\n}\n\n.rt-action-menu button:hover:not(:disabled),\n.rt-action-menu [role='menuitem']:hover:not(:disabled),\n.rt-action-menu button:focus-visible:not(:disabled),\n.rt-action-menu [role='menuitem']:focus-visible:not(:disabled) {\n  background: rgba(59, 130, 246, 0.08) !important;\n  background-color: rgba(59, 130, 246, 0.08) !important;\n}\n\n[data-theme='dark'] .rt-action-menu button:hover:not(:disabled),\n[data-theme='dark'] .rt-action-menu [role='menuitem']:hover:not(:disabled),\n[data-theme='dark'] .rt-action-menu button:focus-visible:not(:disabled),\n[data-theme='dark'] .rt-action-menu [role='menuitem']:focus-visible:not(:disabled) {\n  background: rgba(59, 130, 246, 0.12) !important;\n  background-color: rgba(59, 130, 246, 0.12) !important;\n}\n\n.rt-action-menu .rt-action-menu__item--danger:hover:not(:disabled) {\n  background: var(--danger-muted, rgba(220, 38, 38, 0.12)) !important;\n  background-color: var(--danger-muted, rgba(220, 38, 38, 0.12)) !important;\n}\n\n.rt-action-menu .rt-action-menu__divider {\n  background: var(--border-subtle, var(--border)) !important;\n  box-shadow: none !important;\n  border: none !important;\n  height: 1px !important;\n}\n\n.modal-overlay,\n.ReactModal__Overlay,\n.modal-backdrop,\n.create-test-case-modal-overlay,\n.create-test-case-options-modal-overlay,\n.extension-recording-modal-overlay {\n  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65)) !important;\n}\n\n.modal.view-mode,\n.view-mode {\n  background-color: var(--bg-tertiary) !important;\n  border-color: var(--border) !important;\n}\n\n/* Portal filter menus (inline styles often hardcode white) */\n.rt-filter-menu,\n[class*=\"filter\"][role=\"listbox\"],\nul[role=\"listbox\"] {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n  box-shadow: var(--shadow-lg) !important;\n}\n\nul[role=\"listbox\"] li,\nul[role=\"listbox\"] button {\n  color: var(--text-primary) !important;\n}\n\nul[role=\"listbox\"] li:hover,\nul[role=\"listbox\"] button:hover {\n  background: var(--surface-hover) !important;\n}\n\n/* ─── Buttons ─── */\n.navbar-button.primary,\n.btn-primary,\n.btn.primary,\nbutton.primary {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: #fff !important;\n}\n\n.navbar-button.primary:hover,\n.btn-primary:hover {\n  background: var(--primary-hover) !important;\n}\n\n.navbar-button.secondary,\n.btn-secondary,\n.btn.secondary,\nbutton.secondary {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.navbar-button.secondary:hover,\n.btn-secondary:hover {\n  background: var(--surface-hover) !important;\n}\n\n.navbar-button:not(.primary):not(.secondary) {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.navbar-button:disabled,\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ─── Badges (subtle tinted) ─── */\n.badge-success,\n.status-badge.passed,\n.status-passed,\n.badge.passed {\n  background: var(--success-muted) !important;\n  color: var(--success) !important;\n  border: none !important;\n}\n\n.badge-warning,\n.status-badge.pending,\n.status-pending,\n.badge.pending,\n.badge.warning {\n  background: var(--warning-muted) !important;\n  color: var(--warning) !important;\n  border: none !important;\n}\n\n.badge-danger,\n.status-badge.failed,\n.status-failed,\n.badge.failed,\n.badge.danger {\n  background: var(--danger-muted) !important;\n  color: var(--danger) !important;\n  border: none !important;\n}\n\n.badge-primary,\n.status-badge.active,\n.badge.info {\n  background: var(--primary-muted) !important;\n  color: var(--primary) !important;\n  border: none !important;\n}\n\n/* ─── Status tabs ─── */\n.projects-container .border-gray-300,\n.status-tabs-container {\n  border-color: var(--border) !important;\n}\n\n.status-tab {\n  background: var(--surface) !important;\n  color: var(--text-secondary) !important;\n  border-color: var(--border) !important;\n}\n\n.status-tab.active {\n  background: var(--primary-muted) !important;\n  color: var(--primary) !important;\n  border-color: transparent !important;\n}\n\n/* ─── Welcome banner ─── */\n.welcome-banner {\n  background: var(--primary-muted) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl, 12px);\n  color: var(--text-primary);\n}\n\n.welcome-banner-title {\n  color: var(--text-primary) !important;\n}\n\n.welcome-banner-message {\n  color: var(--text-secondary) !important;\n}\n\n/* ─── Tooltips ─── */\n.tooltip,\n[role=\"tooltip\"],\n.recharts-tooltip-wrapper .recharts-default-tooltip {\n  background: var(--chart-tooltip-bg, var(--surface-elevated)) !important;\n  color: var(--chart-tooltip-text, var(--text-primary)) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-md) !important;\n}\n\n/* ─── Charts ─── */\n.recharts-wrapper,\n.recharts-surface {\n  background: transparent !important;\n}\n\n.recharts-cartesian-grid line {\n  stroke: var(--chart-grid) !important;\n}\n\n.recharts-text,\n.recharts-cartesian-axis-tick-value {\n  fill: var(--chart-tick) !important;\n}\n\n/* ─── Pagination (align legacy wrappers with soft RT2 theme) ─── */\n.pagination,\n.pagination-container,\n.Pagination {\n  color: var(--text-muted);\n}\n\n.pagination .rt-pagination,\n.pagination-container .rt-pagination,\n.project-pagination .rt-pagination {\n  border-top-color: var(--border-subtle);\n}\n\n.pagination button,\n.pagination a,\n.page-btn,\n.pagination-btn,\n.pagination-button {\n  background: transparent !important;\n  color: var(--text-secondary) !important;\n  border-color: transparent !important;\n  border-radius: 999px !important;\n}\n\n.pagination button:hover:not(:disabled),\n.pagination a:hover,\n.page-btn:hover:not(:disabled),\n.pagination-btn:hover:not(:disabled),\n.pagination-button:hover:not(:disabled) {\n  background: var(--surface-hover, rgba(15, 23, 42, 0.04)) !important;\n  color: var(--text-primary) !important;\n}\n\n.pagination button.active,\n.page-btn.active,\n.pagination .active,\n.pagination-btn.active {\n  background: var(--primary-muted) !important;\n  color: var(--primary) !important;\n  border-color: transparent !important;\n}\n\n/* ─── Error / empty states ─── */\n.error-state,\n.empty-state,\n.rt-error-state,\n.rt-empty-state {\n  background: var(--surface);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n}\n\n/* ─── Learning / AI page ─── */\n.learning-system,\n.learning-container {\n  background: var(--bg-primary) !important;\n}\n\n.learning-system .card,\n.learning-system .panel,\n.feedback-card {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Reports ─── */\n.report-page-container,\n.reports-container,\n.detailed-report-container {\n  background: var(--bg-primary) !important;\n}\n\n.metric-card,\n.report-metric,\n.kpi-card {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n/* ─── Test plans / executions ─── */\n.test-plans-container .empty-state,\n.test-plans-error,\n.projects-error {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Workspaces ─── */\n.all-workspaces-container .workspace-card,\n.workspace-item {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Project list sticky / layout ─── */\n.projects-container.projects-list-layout {\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n/* ─── Hardcoded white/light remnants inside dark mode ─── */\n[data-theme=\"dark\"] .bg-white,\n[data-theme=\"dark\"] .bg-gray-50,\n[data-theme=\"dark\"] .bg-gray-100,\n[data-theme=\"dark\"] [style*=\"background: white\"],\n[data-theme=\"dark\"] [style*=\"background: #fff\"],\n[data-theme=\"dark\"] [style*=\"background:#fff\"],\n[data-theme=\"dark\"] [style*=\"background-color: white\"],\n[data-theme=\"dark\"] [style*=\"background-color: #fff\"],\n[data-theme=\"dark\"] [style*=\"backgroundColor: '#fff'\"] {\n  background-color: var(--surface) !important;\n}\n\n[data-theme=\"dark\"] .text-gray-900,\n[data-theme=\"dark\"] .text-black {\n  color: var(--text-primary) !important;\n}\n\n[data-theme=\"dark\"] .text-gray-500,\n[data-theme=\"dark\"] .text-gray-600 {\n  color: var(--text-secondary) !important;\n}\n\n[data-theme=\"dark\"] .border-gray-200,\n[data-theme=\"dark\"] .border-gray-300 {\n  border-color: var(--border) !important;\n}\n\n/* ─── Layout / scroll stabilization for legacy page roots ─── */\n.test-cases-overview-container,\n.test-suites-overview-container,\n.test-suites-container,\n.test-plans-container,\n.projects-container,\n.projects-container.projects-list-layout,\n.all-workspaces-container,\n.learning-system,\n.learning-container,\n.settings-container,\n.report-page-container,\n.reports-container,\n.jira-items-container,\n.optimization-container,\n.ai-testcase-generator-container,\n.detailed-report-container,\n.schedule-plan-container,\n.dashboard-container,\n.dashboard-content {\n  height: auto !important;\n  max-height: none !important;\n  min-height: 0 !important;\n  overflow: visible !important;\n}\n\n.projects-table-container,\n.test-cases-table-container,\n.test-suites-table-container,\n.test-plans-table-wrapper,\n.rt-table-wrap,\n.rt2-table-wrap {\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n  max-height: none !important;\n}\n\n/* ─── react-select theming ───\n   IMPORTANT: always require the emotion `css-` prefix.\n   Bare [class*=\"-menu\"] also matched our product classes\n   (e.g. rt-action-menu__label) and painted every nested\n   text node as its own bordered/shadowed surface. */\n.css-13cymwt-control,\n.css-t3ipsp-control,\n[class*=\"css-\"][class*=\"-control\"] {\n  background-color: var(--input-background) !important;\n  border-color: var(--input-border) !important;\n  color: var(--text-primary) !important;\n  min-height: 40px !important;\n  border-radius: var(--radius-md) !important;\n}\n\n[class*=\"css-\"][class*=\"-menu\"] {\n  background-color: var(--surface-raised, var(--surface)) !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-md) !important;\n  color: var(--text-primary) !important;\n}\n\n[class*=\"css-\"][class*=\"-option\"] {\n  background-color: transparent !important;\n  color: var(--text-primary) !important;\n}\n\n[class*=\"css-\"][class*=\"-option\"]:hover,\n[class*=\"css-\"][class*=\"-option--is-focused\"] {\n  background-color: var(--surface-hover) !important;\n}\n\n[class*=\"css-\"][class*=\"-singleValue\"],\n[class*=\"css-\"][class*=\"-Input\"] input,\n[class*=\"css-\"][class*=\"-placeholder\"] {\n  color: var(--text-primary) !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n[class*=\"css-\"][class*=\"-placeholder\"] {\n  color: var(--input-placeholder) !important;\n}\n\n[class*=\"css-\"][class*=\"-multiValue\"] {\n  background: var(--primary-muted) !important;\n}\n\n[class*=\"css-\"][class*=\"-multiValue__label\"] {\n  color: var(--primary) !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n/* Toast / notification surfaces */\n.Toastify__toast,\n.toast {\n  background: var(--surface-elevated) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border);\n}\n\n\n/* ─── Create Test Case options / form / extension modals ─── */\n.create-test-case-options-modal-panel,\n.create-test-case-modal-panel,\n.extension-recording-modal-panel {\n  background: var(--modal-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border-strong, var(--border)) !important;\n  box-shadow: var(--modal-shadow, var(--shadow-lg)) !important;\n}\n\n.create-test-case-options-modal-body,\n.create-test-case-modal-panel .modal-body {\n  background: var(--modal-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Light: keep footer flush with body so it doesn’t look muddy gray-on-white */\n[data-theme=\"light\"] .create-test-case-options-modal-footer,\n:root:not([data-theme=\"dark\"]) .create-test-case-options-modal-footer,\n[data-theme=\"light\"] .create-test-case-modal-panel .modal-footer,\n:root:not([data-theme=\"dark\"]) .create-test-case-modal-panel .modal-footer {\n  background: var(--modal-background, #fff) !important;\n  border-top: 1px solid var(--border) !important;\n}\n\n[data-theme=\"dark\"] .create-test-case-options-modal-footer,\n[data-theme=\"dark\"] .create-test-case-modal-panel .modal-footer {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  border-top: 1px solid var(--border) !important;\n}\n\n.create-test-case-option-btn {\n  background: var(--surface-raised, var(--surface)) !important;\n  border: 1px solid var(--border-strong, var(--border)) !important;\n  color: var(--text-primary) !important;\n  box-shadow: var(--shadow-xs);\n}\n\n[data-theme=\"light\"] .create-test-case-option-btn,\n:root:not([data-theme=\"dark\"]) .create-test-case-option-btn {\n  background: #fff !important;\n  border-color: #CBD5E1 !important;\n}\n\n.create-test-case-option-btn:hover {\n  border-color: var(--primary) !important;\n  background: var(--primary-muted) !important;\n}\n\n.create-test-case-option-btn.extension:hover {\n  border-color: #22c55e !important;\n  background: rgba(34, 197, 94, 0.14) !important;\n}\n\n.create-test-case-option-btn.disabled:hover {\n  border-color: var(--border) !important;\n  background: var(--surface-hover) !important;\n}\n\n.create-test-case-option-title {\n  color: var(--text-primary) !important;\n}\n\n.create-test-case-option-desc {\n  color: var(--text-secondary) !important;\n}\n\n.create-test-case-options-cancel-btn {\n  color: var(--text-secondary) !important;\n}\n\n.create-test-case-options-cancel-btn:hover {\n  color: var(--text-primary) !important;\n  background: var(--surface-hover) !important;\n}\n\n.create-test-case-option-icon.manual {\n  background: var(--primary-muted) !important;\n}\n\n.create-test-case-option-icon.extension {\n  background: rgba(34, 197, 94, 0.18) !important;\n}\n\n.create-test-case-option-coming-soon {\n  background: var(--bg-tertiary) !important;\n  color: var(--text-secondary) !important;\n  border: 1px solid var(--border);\n}\n\n/* Light scrim: dim the page enough that a white modal clearly floats */\n[data-theme=\"light\"] .create-test-case-options-modal-overlay,\n[data-theme=\"light\"] .create-test-case-modal-overlay,\n[data-theme=\"light\"] .extension-recording-modal-overlay,\n:root:not([data-theme=\"dark\"]) .create-test-case-options-modal-overlay,\n:root:not([data-theme=\"dark\"]) .create-test-case-modal-overlay,\n:root:not([data-theme=\"dark\"]) .extension-recording-modal-overlay {\n  background: rgba(15, 23, 42, 0.48) !important;\n  backdrop-filter: blur(2px);\n}\n\n[data-theme=\"dark\"] .create-test-case-options-modal-overlay,\n[data-theme=\"dark\"] .create-test-case-modal-overlay,\n[data-theme=\"dark\"] .extension-recording-modal-overlay {\n  background: rgba(2, 8, 20, 0.72) !important;\n  backdrop-filter: blur(3px);\n}\n\n/* ─── Test plan modals (create / link suites / run) ─── */\n.link-test-suites-modal-overlay,\n.test-execution-modal-overlay,\n.rt-run-plan-overlay {\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55)) !important;\n}\n\n[data-theme=\"dark\"] .link-test-suites-modal-overlay,\n[data-theme=\"dark\"] .test-execution-modal-overlay,\n[data-theme=\"dark\"] .rt-run-plan-overlay {\n  background: rgba(2, 8, 20, 0.72) !important;\n  backdrop-filter: blur(3px);\n}\n\n.link-test-suites-modal,\n.test-execution-modal,\n.rt-run-plan-panel {\n  background: var(--modal-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--modal-shadow, var(--shadow-lg)) !important;\n}\n\n.link-test-suites-modal .modal-header,\n.test-execution-modal .modal-header,\n.rt-run-plan-panel .rt-run-plan-header {\n  background: linear-gradient(to right, var(--primary), var(--primary-hover)) !important;\n  border-bottom-color: transparent !important;\n}\n\n.link-test-suites-modal .modal-content,\n.link-test-suites-modal-form,\n.test-execution-modal .modal-content,\n.test-execution-modal-form {\n  background: var(--modal-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n}\n\n.link-test-suites-modal .modal-footer,\n.test-execution-modal .modal-footer,\n.rt-run-plan-panel .rt-run-plan-footer {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  border-top: 1px solid var(--border) !important;\n}\n\n[data-theme=\"light\"] .link-test-suites-modal .modal-footer,\n[data-theme=\"light\"] .test-execution-modal .modal-footer,\n[data-theme=\"light\"] .rt-run-plan-panel .rt-run-plan-footer {\n  background: var(--modal-background, #fff) !important;\n}\n\n.link-test-suites-modal .suite-item,\n.link-test-suites-modal .test-suites-vertical-list,\n.link-test-suites-modal .test-suites-container {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.link-test-suites-modal .suite-item:hover,\n.link-test-suites-modal .suite-item.selected {\n  background: var(--primary-muted) !important;\n  border-color: var(--primary) !important;\n}\n\n.link-test-suites-modal .suite-name,\n.link-test-suites-modal .selection-count,\n.link-test-suites-modal .form-group > label,\n.link-test-suites-modal .empty-state,\n.link-test-suites-modal .loading-state {\n  color: var(--text-primary) !important;\n}\n\n.link-test-suites-modal .btn.secondary,\n.test-execution-modal .btn.secondary {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n}\n\n.link-test-suites-modal .btn.primary,\n.test-execution-modal .btn.primary {\n  background: var(--primary) !important;\n  color: #fff !important;\n  border: 1px solid transparent !important;\n}\n\n.link-test-suites-modal .btn.danger {\n  background: var(--danger) !important;\n  color: #fff !important;\n}\n\n.test-execution-modal .form-group > label,\n.test-execution-modal .form-info p,\n.test-execution-field-hint {\n  color: var(--text-secondary) !important;\n}\n\n.test-execution-modal input,\n.test-execution-modal textarea,\n.test-execution-modal select {\n  background: var(--input-background) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--input-border) !important;\n}\n\n/* View plan modal (edit) */\n.rt-plan-as-page,\n.rt-plan-as-page > div {\n  background: transparent !important;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Global: kill accidental text-level surfaces ─── */\n.rt2-main p,\n.rt2-main h1,\n.rt2-main h2,\n.rt2-main h3,\n.rt2-main h4,\n.rt2-main h5,\n.rt2-main h6,\n.rt2-main label,\n.rt2-main small,\n.rt2-main strong,\n.rt2-main em,\n.rt2-main .page-subtitle,\n.rt2-main .section-subtitle,\n.rt2-main .breadcrumb,\n.rt2-main .breadcrumb *,\n.rt2-cmd__item-title,\n.rt2-cmd__item-desc,\n.rt2-sidebar__label,\n.rt2-topbar__crumb,\n.dropdown-menu button,\n.dropdown-menu span,\n.action-submenu-item,\n.action-submenu-item span,\nul[role=\"listbox\"] [role=\"option\"],\nul[role=\"listbox\"] [role=\"option\"] * {\n  text-shadow: none;\n}\n\n.rt2-main p,\n.rt2-main h1,\n.rt2-main h2,\n.rt2-main h3,\n.rt2-main h4,\n.rt2-main h5,\n.rt2-main h6,\n.rt2-main label:not([class*=\"toggle\"]):not([class*=\"switch\"]),\n.rt2-main small,\n.rt2-main strong,\n.rt2-main em,\n.rt2-cmd__item-title,\n.rt2-cmd__item-desc,\n.dropdown-menu span,\n.action-submenu-item span,\nul[role=\"listbox\"] [role=\"option\"] span {\n  background: transparent;\n  box-shadow: none;\n}\n\n.dropdown-menu,\n.filter-dropdown-menu,\n.rt-dropdown,\n.rt-filter-menu,\nul[role=\"listbox\"] {\n  background: var(--surface-raised, var(--surface)) !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-md) !important;\n  color: var(--text-primary) !important;\n}\n\n.dropdown-menu button:hover,\n.action-submenu-item:hover:not(:disabled),\nul[role=\"listbox\"] [role=\"option\"]:hover,\nul[role=\"listbox\"] [role=\"option\"][aria-selected=\"true\"] {\n  background: rgba(59, 130, 246, 0.08) !important;\n}\n\n[data-theme=\"dark\"] .dropdown-menu button:hover,\n[data-theme=\"dark\"] .action-submenu-item:hover:not(:disabled),\n[data-theme=\"dark\"] ul[role=\"listbox\"] [role=\"option\"]:hover,\n[data-theme=\"dark\"] ul[role=\"listbox\"] [role=\"option\"][aria-selected=\"true\"] {\n  background: rgba(59, 130, 246, 0.12) !important;\n}\n\n/* ─── Legacy light surfaces → tokens (Jira / scenarios / modals / cards) ─── */\n.jira-items-content,\n.jira-items-tabs {\n  background: transparent !important;\n  background-color: transparent !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n  box-shadow: none !important;\n}\n\n.epic-details,\n.epic-dropdown,\n.test-cases-modal,\n.test-cases-modal-content,\n.test-cases-modal-body,\n.scenario-test-cases,\n.editable-parameter-group,\n.analysis-results,\n.item-details,\n.test-case-card,\n.test-plan-card,\n.test-suite-card,\n.test-case-editor {\n  background: var(--surface) !important;\n  background-color: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.ai-testcase-generator-overlay.rt-scenario-page {\n  background: transparent !important;\n}\n\n.ai-testcase-generator-container.rt-scenario-panel,\n.rt-scenario-page .ai-testcase-generator-container,\n.generator-content {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n}\n\n.bdd-step,\n.expected-result,\n.collapsed-summary,\n.parameter-value {\n  background: var(--bg-tertiary, var(--surface-hover)) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Flat typography — never invent boxes behind labels */\n.test-case-section h4,\n.test-case-section > h4,\n.test-strategy-section h4,\n.test-suites-section h4,\n.scenario-test-cases h4,\n.epic-stories h4,\n.ai-testcase-generator-container h3,\n.ai-testcase-generator-container h4,\n.ai-testcase-generator-container label,\n.jira-items-container h3,\n.jira-items-container h4,\n.jira-items-container label,\n.rt2-main h1,\n.rt2-main h2,\n.rt2-main h3,\n.rt2-main h4,\n.rt2-main h5,\n.rt2-main h6,\n.rt2-main p,\n.rt2-main label:not([class*=\"toggle\"]):not([class*=\"switch\"]),\n.rt2-main small,\n.rt2-main strong,\n.rt2-main em {\n  background: transparent !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n}\n\n.epic-dropdown label,\n.epic-dropdown select {\n  color: var(--text-primary) !important;\n}\n\n.epic-dropdown select {\n  background: var(--input-background, var(--surface)) !important;\n  border-color: var(--input-border, var(--border)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
